export const userLookup = () => {
  if ( localStorage.getItem('user') === null && sessionStorage.getItem('user') === null ) {
    return null;
  }

  const user = localStorage.getItem('user') ? JSON.parse( localStorage.getItem('user') ) : JSON.parse( sessionStorage.getItem('user'))
  return user;
}
